import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpStoreReferringSpecialist, HttpStoreReferringSpecialistOptions} from '../http/referring-specialists.http'
import {ReferringSpecialist} from '@/features/referring-specialists/types'

export const useCreateReferringSpecialist = (
    options?: Omit<
        UseMutationOptions<ReferringSpecialist, unknown, HttpStoreReferringSpecialistOptions['payload']>,
        'mutationFn'
    >
) => {
    const queryClient = useQueryClient()
    return useMutation({
        ...options,
        mutationFn: payload =>
            httpStoreReferringSpecialist({
                payload
            }),
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: ['referring-specialists']})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
